import { toRefs } from '@vueuse/core';
import { computed, getCurrentInstance, reactive } from '@vue/composition-api';
import { FlowProps, GraphEdge, GraphNode, WorkFlowStore } from '../types';
import { useActions, useGetters, useState } from '../store';

/**
 * @deprecated will be removed in the next major and replaced with a ctx based solution similar to `<ReactFlowProvider>`
 *
 * Stores all existing VueFlow state instances
 */
export class Storage {
  public currentId = 0;
  public flows = new Map<string, WorkFlowStore>();
  static instance: Storage;

  public static getInstance(): Storage {
    // todo: this is just a workaround for now, in the next major this class won't exist and the state will be ctx-based (like React Provider)
    const vueApp = getCurrentInstance(); //?.appContext.app

    // const existingInstance = vueApp?.config.globalProperties.$workFlowStorage ?? Storage.instance

    Storage.instance = Storage.instance ?? new Storage();

    // if (vueApp) {
    //   vueApp.config.globalProperties.$workFlowStorage = Storage.instance
    // }

    return Storage.instance;
  }

  public set(id: string, flow: WorkFlowStore) {
    return this.flows.set(id, flow);
  }

  public get(id: string) {
    return this.flows.get(id);
  }

  public remove(id: string) {
    return this.flows.delete(id);
  }

  public create(id: string, preloadedState?: FlowProps): WorkFlowStore {
    const state = useState();

    const reactiveState = reactive(state);

    const hooksOn = <any>{};
    for (const [n, h] of Object.entries(reactiveState.hooks)) {
      const name = `on${n.charAt(0).toUpperCase() + n.slice(1)}`;
      hooksOn[name] = h.on;
    }

    const emits = <any>{};
    for (const [n, h] of Object.entries(reactiveState.hooks)) {
      emits[n] = h.trigger;
    }

    // for lookup purposes
    const nodeLookup = computed(() => {
      const nodesMap = new Map<string, GraphNode>();
      for (const node of reactiveState.nodes) {
        nodesMap.set(node.id, node);
      }

      return nodesMap;
    });

    const edgeLookup = computed(() => {
      const edgesMap = new Map<string, GraphEdge>();

      for (const edge of reactiveState.edges) {
        edgesMap.set(edge.id, edge);
      }

      return edgesMap;
    });

    const getters = useGetters(reactiveState, nodeLookup);

    const actions = useActions(reactiveState, nodeLookup, edgeLookup);

    actions.setState({ ...reactiveState, ...preloadedState });

    const flow: WorkFlowStore = {
      ...hooksOn,
      ...getters,
      ...actions,
      ...toRefs(reactiveState),
      nodeLookup,
      edgeLookup,
      emits,
      id,
      $destroy: () => {
        this.remove(id);
      }
    };

    this.set(id, flow);

    return flow;
  }

  public getId() {
    return `workflow-${this.currentId++}`;
  }
}
